// extracted by mini-css-extract-plugin
module.exports = {"root":"z0m6j","truncated":"_3rw_e"};